import { useSelector } from 'react-redux'

import { AFFILIATE_OWNER_MANAGES_TEAM } from '../config/featureFlagKeys'
import { selectFeatureFlag, selectFeatureFlagsSettled } from '../features/featureFlags/selectors'
import { resolveActiveOffice, useOfficeVisibility } from './useOfficeVisibility'

const NONE = { canManageTeam: false, kind: null, activeOffice: null }

export const useTeamManager = (user) => {
  const flagOn = useSelector(selectFeatureFlag(AFFILIATE_OWNER_MANAGES_TEAM))
  const flagsSettled = useSelector(selectFeatureFlagsSettled)
  const { offices, resolved: officesResolved } = useOfficeVisibility(user)
  const role = user?.role

  if (!user || !flagsSettled) return { ...NONE, resolved: false }
  if (!flagOn) return { ...NONE, resolved: true }
  if (role === 'affiliateGroupsAdmin') return { canManageTeam: true, kind: 'groupAdmin', activeOffice: null, resolved: true }
  if (role !== 'affiliate') return { ...NONE, resolved: true }
  if (!officesResolved) return { ...NONE, resolved: false }

  const activeOffice = resolveActiveOffice(offices, localStorage.getItem('activeOfficeId'))

  return activeOffice?.isOwner
    ? { canManageTeam: true, kind: 'owner', activeOffice, resolved: true }
    : { ...NONE, resolved: true }
}
